export default __webpack_public_path__ + "static/media/Little Sun.2d1aac9e.jpg";